import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { PageHeader, Spinner, EmptyState } from "@/components/common";

const FALLBACK = "https://images.unsplash.com/photo-1544785349-c4a5301826fd?crop=entropy&cs=srgb&fm=jpg&q=70&w=500";

export default function Founders() {
  const [founders, setFounders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/founders").then((r) => setFounders(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div data-testid="founders-page">
      <PageHeader caption="The Team" title="Founders & Creators" subtitle="The people behind the moments — the vision, the craft and the energy of Sirakh Creations." />
      <div className="mx-auto max-w-6xl px-4 pb-10 sm:px-8">
        {loading ? <Spinner /> : founders.length ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {founders.map((f) => (
              <div key={f.id} className="card-dark overflow-hidden text-center transition-colors hover:border-[#D4AF37]/50" data-testid={`founder-card-${f.id}`}>
                <div className="aspect-square overflow-hidden bg-[#0A0A0C]">
                  <img src={f.photo ? fileUrl(f.photo) : FALLBACK} alt={f.name} loading="lazy" className="h-full w-full object-cover" onError={(e) => { e.currentTarget.src = FALLBACK; }} />
                </div>
                <div className="p-5">
                  <h3 className="font-serif text-xl font-semibold">{f.name}</h3>
                  {f.role && <p className="mt-0.5 text-xs uppercase tracking-wider text-[#E5C158]">{f.role}</p>}
                  {f.bio && <p className="mt-3 text-sm leading-relaxed text-zinc-400">{f.bio}</p>}
                </div>
              </div>
            ))}
          </div>
        ) : <EmptyState text="Team members will be introduced here soon." />}
      </div>
    </div>
  );
}
